import styled from 'styled-components';
import { getSpacingToken, getToken } from '@optimus-web/common';
import { Container } from '../Container';
import { Stack } from '../Stack';
import { getTypographyOptions, TypographyOptions } from '../typography';
import { getBannerBackgroundColor, getBannerColor } from './getBannerStyles';
import { BannerVariant } from './types';

export const BannerElement = styled(Stack)<{ variant: BannerVariant }>`
    box-sizing: border-box;
    color: ${({ variant }) => getBannerColor(variant)};
    background-color: ${({ variant }) => getBannerBackgroundColor(variant)};
    border-radius: ${getToken('borderRadius100')}px;
    padding: ${getSpacingToken('150')}px ${getSpacingToken('150')}px ${getSpacingToken('200')}px
        ${getSpacingToken('200')}px;
`;

export const LinkContainer = styled(Container)<TypographyOptions>`
    ${getTypographyOptions}
`;
